import { tv, type VariantProps } from 'tailwind-variants'

export const placeholderLine = tv({
  base: 'overflow-hidden',
  variants: {
    size: {
      sm: 'h-4',
      md: 'h-6',
      lg: 'h-8',
      xl: 'h-10',
      '2xl': 'h-12',
      '3xl': 'h-18',
    },
    length: {
      full: 'w-full',
      half: 'w-1/2',
      custom: {},
    },
    radius: {
      none: 'rounded-none',
      sm: 'rounded-lg',
      md: 'rounded-xl',
      lg: 'rounded-2xl',
      full: 'rounded-full',
    },
    contrast: {
      dark: 'bg-default-bg-loading-dark',
      light: 'bg-default-bg-loading',
    },
  },
  defaultVariants: {
    size: 'md',
    radius: 'lg',
    contrast: 'dark',
    length: 'full',
  },
})

export type TPlaceholderLineVariantProps = VariantProps<typeof placeholderLine>
